<template>
  <div class="box">
    <ShowGr v-if="!$IsPhone&&showInfo&&!type&&inqtype!='2'" :showInfo="showInfo"></ShowGr>
    <ShowGrM v-if="$IsPhone&&showInfo&&!type&&inqtype!='2'" :showInfo="showInfo"></ShowGrM>
    <ShowQy v-if="showInfo&&type=='qy'&&inqtype!='2'" :showInfo="showInfo"></ShowQy>
    <ShowKt v-if="showInfo&&inqtype=='2'" :showInfo="showInfo"></ShowKt>
    <!-- <ShowQyM v-if="$IsPhone&&showInfo&&type=='qy'" :showInfo="showInfo"></ShowQyM> -->
  </div>
</template>
<script>
import ShowGr from './show/ShowGr.vue';
import ShowQy from './show/ShowQy.vue';
import ShowQyM from './show/ShowQyM.vue';
import ShowGrM from './show/ShowGrM.vue';
import ShowKt from './show/ShowKt.vue';
const rate = window.outerWidth / 375;
import { certificateGR ,certificateQY} from '@/request/index';

export default {
  metaInfo: {
    title: '培训信息查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "show",
  components: {
    ShowGr,//人员证书
    ShowGrM,
    ShowQy,
    ShowQyM,
    ShowKt
  },
  data() {
    return {
      showInfo: null,
      selectid:"",
      type:'',
      inqtype:''
    }
  },
  created() {
    this.query();
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
     */
    async query() {

      let { name, code, certtypename,type,inqType } = this.$route.query;
      this.type = type;
      this.inqtype = inqType;
      try{
        let result
        if(type=='qy')
        {
          result = await certificateQY(certtypename,code, name,'');
        }
        else{
          result = await certificateGR(certtypename,code, name,'');
        } 
        if (result.success) {
          this.showInfo = result.data[0];
        } else {
          this.showInfo = null; 
          this.$router.push('/inquery');
        }
      }catch(err){
          this.showInfo = null; 
            this.$router.push('/inquery'); 
      }
    },
    /**
     * nianjian转Array
     * "第一年,第二年,第三年"
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealNianjian(obj) {
      return obj;
    },
    /**
     * 技术支持单位
     * 名称##网址||名称##网址
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealJszcdw(obj) {
      return obj;
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>